/** @format */

import React, { FunctionComponent } from 'react';
import PliCbd2Interface from '../../../interfaces/platform/PliCbd2Interface';
import { TableRow } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { PlatformResellerLoader } from '../../../modules/platformreseller/PlatformResellerLoader';
import { MnpEventType } from '../MnpEventType';
import I18n from '../../../components/Translate/I18n';
import { AcqOperatorLoader } from '../../../modules/mnp/AcqOperatorLoader';

const _ = require('underscore');

export type MnpAllRowType = {
    pliCbd2: PliCbd2Interface;
    acqOperators: AcqOperatorLoader;
    platformResellerLoader: PlatformResellerLoader;
    mnpEventType: MnpEventType;
    classes: any;
    setActiveRow: (id: number) => void;
    rowActiveColor: string;
    hideCols?: Array<string>;
};

export const MnpAllRow: FunctionComponent<MnpAllRowType> = ({
    pliCbd2,
    classes,
    acqOperators,
    platformResellerLoader,
    mnpEventType,
    setActiveRow,
    rowActiveColor,
    hideCols,
}) => {
    const tableCellRoot = { root: classes.tableCellRoot };
    const tableRowRoot = { root: classes.tableRowRoot };

    const getOperatorName = (operatorRpt: string | null): string | null => {
        return acqOperators.getOperatorNameByRpt(operatorRpt, true);
    };

    const getPartnerName = (partner: string): React.ReactNode | null => {
        return platformResellerLoader.getPlatformResellerNameByUri(partner);
    };

    const getEventName = (donor: boolean): React.ReactNode | null => {
        return <I18n trans={mnpEventType.getI18Name(pliCbd2.eventType, donor)} />;
    };

    return (
        <TableRow
            onClick={(): void => {
                setActiveRow(pliCbd2.id);
            }}
            classes={tableRowRoot}
            style={{ backgroundColor: rowActiveColor }}
            hover
        >
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {pliCbd2.caseId}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {pliCbd2.platformReseller && getEventName(true)}
                {pliCbd2.recipientPlatformReseller && getEventName(false)}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {pliCbd2.msisdn}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {pliCbd2.platformReseller && getPartnerName(pliCbd2.platformReseller)}
                {pliCbd2.recipientPlatformReseller && getPartnerName(pliCbd2.recipientPlatformReseller)}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {pliCbd2.searchEventDateTime && DateHelperTs.format(pliCbd2.searchEventDateTime, 'YYYY-MM-DD')}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {pliCbd2.donor}
                <div style={{ height: '20px' }}>{getOperatorName(pliCbd2.donor)}</div>
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {pliCbd2.recipient}
                <div style={{ height: '20px', padding: '0px 10px 0px 10px' }}>{getOperatorName(pliCbd2.recipient)}</div>
            </TableCell>
        </TableRow>
    );
};
